import Vue from 'vue'
import VueRouter from 'vue-router'
import GameCC from '../views/GameCC.vue'
import Login from '../views/Login.vue'
import Lounge from '../views/Lounge.vue'
import GameWITT from '../views/GameWITT.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [{
    //if page not found, go to login page
    path: '*',
    component: Login
  },
  {
    path: '/game-code-challenge',
    name: 'game-code-challenge',
    component: GameCC
  },
  {
    path: '/game-where-is-the-target',
    name: 'game-where-is-the-target',
    component: GameWITT
  },
  {
    path: '/lounge',
    name: 'lounge',
    component: Lounge
  },
  {
    path: '/',
    name: 'login',
    component: Login
  },
  ]
})

export default router
